
import { sampleSize } from "lodash"
import {AnswerType} from "@/dataType";

export function formatSample(coverArr:AnswerType[]) {
    coverArr.forEach((item) => {
        item.answers = sampleSize(item.answers, item.answers.length)
    })
    coverArr = sampleSize(coverArr, coverArr.length)
    return coverArr
}

export function getUrlParam(paraName: string, url = window.location.href): string {
    const arrObj = url.split("?");

    if (arrObj.length > 1) {
        const arrPara = arrObj[1].split("&");
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");
            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    } else {
        return "";
    }
}

const ua = navigator.userAgent.toLowerCase();

export function env() {
    const isWx = ua.search("micromessenger") !== -1;
    const isNgzb = ua.search("ngzb") !== -1;
    const isAnd = isNgzb && Reflect.has(window, "android");
    const isIos = isNgzb && Reflect.has(window, "webkit");
    const android = Reflect.get(window, 'android')
    const webkit = Reflect.get(window, 'webkit')
    return {
        isWx,
        isNgzb,
        isAnd,
        isIos,
        android,
        webkit,
    };
}

// 分享网页
export function sharePage(params: {
    url: string, title:string, desc: string, img: string
}) {
    const {url,title,desc,img} = params
    const shareData = `{
        "invitecard_href":"",
        "url":"${url}",
        "title":"${title}",
        "desc":"${desc}",
        "image":"${img}"
      }`
    if (env().isAnd) {
        env().android.webpageShare(shareData);
    } else if (env().isIos) {
        env().webkit.messageHandlers.webpageShare.postMessage(shareData);
    } else {
        alert('微信请点击右上角分享')
    }
}

/**
 * 打开新闻，兼容APP内外
 * @param {*} data
 * */
export function openNews(data:any) {
    const webkit = Reflect.get(window, 'webkit')
    const android = Reflect.get(window, 'android')
    console.log(data)
    if (env().isIos) {
        if (typeof data === 'string') {
            data = JSON.parse(data)
        }
        const jsondata = {
            type: "news",
            data: {
                domain: 'https://app-h5.ngzb.com.cn/pureArticle',
                news_id: data.news_id.toString()
            }
        }
        webkit.messageHandlers.openNative.postMessage(jsondata)
    } else if (env().isAnd) {
        if (typeof data !== 'string') {
            data = JSON.stringify(data)
        }
        window.location.href = `https://app-h5.ngzb.com.cn/pureArticle?news_id=${data.news_id}`
        console.log('android',data)
        android.xw_callNewsDetail(data)
    } else {
        if (typeof data === 'string') {
            data = JSON.parse(data)
        }
        window.location.href = `https://app-h5.ngzb.com.cn/shareArticle?news_id=${data.news_id}`
    }
}
